import moment from 'moment';
import 'moment-duration-format';

export default function getDuration(timeInMilliseconds: number) {
  return moment.duration(timeInMilliseconds).format('mm:ss', { trim: false });
}
